/**
 * @barba/core/schemas
 * <br><br>
 * ## Schemas description.
 *
 * @module core/schemas
 * @preferred
 */

/***/

// Definitions
import { ISchemaAttribute } from '../defs';

/**
 * See [[ISchemaAttribute]]
 */
export const schemaAttribute: ISchemaAttribute = {
  container: 'container',
  history: 'history',
  namespace: 'namespace',
  prefix: 'data-barba',
  prevent: 'prevent',
  wrapper: 'wrapper',
};
